
(() => {
  'use strict';
  const KEY = 'wishlist';
  let toastTimer;

  const safeParse = (value, fallback) => {
    try { return JSON.parse(value); } catch (_) { return fallback; }
  };

  function getItems() {
    const raw = safeParse(localStorage.getItem(KEY) || '[]', []);
    if (!Array.isArray(raw)) return [];
    return raw.map((item) => {
      if (typeof item === 'string') return { id: item, url: item };
      return item && typeof item === 'object' ? item : null;
    }).filter(Boolean);
  }

  function saveItems(items) {
    try { localStorage.setItem(KEY, JSON.stringify(items)); } catch (_) {}
    document.dispatchEvent(new CustomEvent('hv:wishlist:change', { detail: { items, count: items.length } }));
  }

  function identity(item) { return String(item.id || item.url || ''); }
  function findIndex(items, id, url) {
    const wantedId = String(id || '');
    return items.findIndex((item) => identity(item) === wantedId || (url && item.url === url));
  }

  function productFromButton(button) {
    return {
      id: String(button.dataset.productId || button.dataset.productUrl || ''),
      handle: button.dataset.productHandle || '',
      title: button.dataset.productTitle || '',
      url: button.dataset.productUrl || '',
      image: button.dataset.productImage || '',
      price: button.dataset.productPrice || ''
    };
  }

  function updateButton(button, active) {
    button.classList.toggle('is-active', active);
    button.setAttribute('aria-pressed', String(active));
    const title = button.dataset.productTitle || 'this product';
    button.setAttribute('aria-label', `${active ? 'Remove' : 'Add'} ${title} ${active ? 'from' : 'to'} wishlist`);
  }

  function syncButtons(root = document) {
    const items = getItems();
    root.querySelectorAll('[data-hv-wishlist-button]').forEach((button) => {
      const product = productFromButton(button);
      updateButton(button, findIndex(items, product.id, product.url) > -1);
    });
    document.querySelectorAll('[data-hv-wishlist-count]').forEach((node) => {
      node.textContent = items.length;
      node.hidden = items.length === 0;
    });
  }

  function showToast(message) {
    let toast = document.querySelector('.hv-wishlist-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'hv-wishlist-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove('is-visible'), 1800);
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-hv-wishlist-button]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();

    const product = productFromButton(button);
    const items = getItems();
    const index = findIndex(items, product.id, product.url);
    const adding = index === -1;
    if (adding) items.push(product); else items.splice(index, 1);
    saveItems(items);
    syncButtons();

    button.classList.remove('is-animating');
    void button.offsetWidth;
    button.classList.add('is-animating');
    setTimeout(() => button.classList.remove('is-animating'), 350);
    showToast(adding ? 'Added to wishlist' : 'Removed from wishlist');
  }, true);

  document.addEventListener('DOMContentLoaded', () => syncButtons());
  document.addEventListener('shopify:section:load', (event) => syncButtons(event.target));
  document.addEventListener('hv:wishlist:change', () => syncButtons());

  const observer = new MutationObserver((mutations) => {
    if (mutations.some((m) => m.addedNodes.length)) syncButtons();
  });
  if (document.documentElement) observer.observe(document.documentElement, { childList: true, subtree: true });
})();
